import styled from 'styled-components';

export const OnBoardingSuccessLoader = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & ion-spinner {
    margin-bottom: 20px;
  }

  & .loading-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 5px;
  }

  & .loading-desc {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #1d201f;
  }
`;
